var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.7998L0.179815 19.4424C0.104742 19.6751 0.3247 19.8951 0.557429 19.82L6.2 17.9998L2 13.7998Z",
    fill: "#1682E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1622 2.60514L3.4043 12.363L7.64687 16.6056L17.4048 6.84771L13.1622 2.60514Z",
    fill: "#1682E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7001 3.1L16.9001 0.3C16.5001 -0.1 15.9001 -0.1 15.5001 0.3L14.6001 1.2L18.8001 5.4L19.7001 4.5C20.1001 4.1 20.1001 3.5 19.7001 3.1Z",
    fill: "#1682E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.018f603679a0428fc2fba1c546d072a9.svg";
export { ForwardRef as ReactComponent };